import React, { useEffect, useState } from "react";
import { Users, CalendarCheck, Building2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (n) => (n === undefined ? "–" : n.toLocaleString("it-IT"));

export const StatsBand = () => {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/stats/public").then((r) => setS(r.data)).catch(() => {}); }, []);
  const items = [
    [Users, fmt(s.providers), "Artisti e fornitori iscritti", "providers"],
    [CalendarCheck, fmt(s.events), "Eventi organizzati tramite il portale", "events"],
    [Building2, fmt(s.entities), "Comuni ed Enti che ci hanno scelto", "entities"],
    [ShieldCheck, "100%", "Sicuro, trasparente e gratuito per gli Enti", "safe"],
  ];
  return (
    <section className="bg-aic-navy text-white" data-testid="home-stats">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 lg:grid-cols-[2fr_1fr] items-center">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {items.map(([Icon, v, l, id], i) => (
            <div key={id} className={`${i > 0 ? "md:border-l md:border-white/15 md:pl-6" : ""}`} data-testid={`stat-${id}`}>
              <Icon className="w-7 h-7 text-gold mb-3"/>
              <div className="font-display text-4xl font-bold" data-testid={`stat-${id}-value`}>{v}</div>
              <div className="text-xs text-white/70 mt-1 leading-snug">{l}</div>
            </div>
          ))}
        </div>
        <p className="font-logo italic text-xl md:text-2xl text-gold leading-snug lg:text-right" data-testid="trust-slogan">
          Il tuo talento merita un palcoscenico: iscriviti oggi e fatti scegliere dai Comuni di tutta Italia.
        </p>
      </div>
    </section>
  );
};
